export enum DateTypes {
    Date,
    Time,
    DateTime,
    TimeSecond,
    DateWithMonthName
}
